
export const Router = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <g clip-path="url(#clip0_77_5297)">
      <path d="M9.3375 18L5.625 27H30.375L26.6625 18H9.3375Z" stroke="#707070" stroke-width="1.5" stroke-linejoin="round" />
      <path d="M7.875 6.75L9.46874 18" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M28.125 6.75L26.5313 18" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18 4.5V18" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.625 27V29.375C5.625 29.9273 6.07272 30.375 6.625 30.375H29.375C29.9273 30.375 30.375 29.9273 30.375 29.375V27" stroke="#707070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_77_5297">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>

}
